import React, { useEffect } from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Router } from '@uhg-abyss/web/ui/Router';
import { Header } from '../Header/Header';
import { Footer } from '../Footer/Footer';
import { TimeoutModal } from '../TimeoutModal/TimeoutModal';
import { getTokenFromStorage } from '@src/utills/storage';
import { registerEvents } from '@repo/ui/src/tools/events';
const HeaderContainer = styled('header', {
  backgroundColor: '$web.semantic.color.surface.container.header.topLevelNav',
  padding: '0 $md',
  height: '100px',
  display: 'flex',
  alignItems: 'center',
});

const ContentContainer = styled('main', {});

export const AppBody = () => {
  useEffect(() => {
    registerEvents();
    // any side effect if this is registered multiple times when it is rendered multiple times
  }, []);

  return (
    <React.Fragment>
      <div
        style={{
          position: 'relative',
          minHeight: `calc(100vh - 45px)`,
          overflowX: 'hidden',
        }}
      >
        <HeaderContainer>
          <Header />
        </HeaderContainer>
        <ContentContainer>
          {/* Checks user's token and displays a modal warning them
            when their session is about to expire */}
          <TimeoutModal />

          <Router.Outlet />
        </ContentContainer>
      </div>
      <div
        style={{
          margin: '0',
          width: '100%',
          position: 'relative',
        }}
      >
        <Footer />
      </div>
    </React.Fragment>
  );
};
